import { ALL_PERMISSION_CODES, P } from './permissions';
const VIEW_ONLY = ALL_PERMISSION_CODES.filter((c) => c.endsWith('_VIEW'));
export const ROLE_TEMPLATES = [
    {
        name: 'Owner',
        description: 'Full control of the business. Cannot be restricted.',
        permissions: null,
        isSystem: true,
    },
    {
        name: 'Administrator',
        description: 'Everything except deleting the business or changing billing.',
        permissions: ALL_PERMISSION_CODES.filter((c) => c !== P.ORGANIZATION_DELETE && c !== P.SUBSCRIPTION_MANAGE),
        isSystem: true,
    },
    {
        name: 'Manager',
        description: 'Runs day-to-day operations for their branch.',
        permissions: [
            P.ORGANIZATION_VIEW, P.USER_VIEW, P.BRANCH_VIEW, P.WAREHOUSE_VIEW,
            P.PRODUCT_VIEW, P.PRODUCT_CREATE, P.PRODUCT_UPDATE, P.PRODUCT_COST_VIEW,
            P.CATEGORY_MANAGE, P.UNIT_MANAGE, P.PRICING_VIEW, P.PRICING_MANAGE,
            P.PROMOTION_MANAGE,
            P.STOCK_VIEW, P.STOCK_ADJUST, P.STOCK_TRANSFER, P.STOCK_TRANSFER_APPROVE,
            P.STOCK_COUNT, P.STOCK_COUNT_APPROVE, P.BATCH_MANAGE, P.SERIAL_MANAGE,
            P.SALE_VIEW, P.SALE_CREATE, P.SALE_UPDATE, P.SALE_CANCEL, P.SALE_REFUND,
            P.SALE_DISCOUNT, P.INVOICE_VIEW, P.INVOICE_ISSUE,
            P.PROPERTY_VIEW, P.PROPERTY_MANAGE, P.PROPERTY_SELL,
            P.POS_ACCESS, P.POS_SESSION_OPEN, P.POS_SESSION_RECONCILE,
            P.CUSTOMER_VIEW, P.CUSTOMER_CREATE, P.CUSTOMER_UPDATE, P.CUSTOMER_CREDIT_MANAGE,
            P.SUPPLIER_VIEW, P.SUPPLIER_CREATE, P.SUPPLIER_UPDATE,
            P.PURCHASE_VIEW, P.PURCHASE_CREATE, P.PURCHASE_UPDATE, P.PURCHASE_APPROVE,
            P.PURCHASE_RECEIVE, P.PURCHASE_RETURN,
            P.PAYMENT_VIEW, P.PAYMENT_CREATE, P.ACCOUNT_MANAGE,
            P.EXPENSE_VIEW, P.EXPENSE_CREATE,
            P.EXPENSE_APPROVE, P.RECEIVABLE_VIEW, P.PAYABLE_VIEW,
            P.DELIVERY_VIEW, P.DELIVERY_MANAGE,
            P.REPORT_VIEW, P.REPORT_FINANCIAL_VIEW, P.REPORT_EXPORT,
        ],
        isSystem: true,
    },
    {
        name: 'Accountant',
        description: 'Money in and money out, with full financial reporting.',
        permissions: [
            P.ORGANIZATION_VIEW, P.BRANCH_VIEW, P.WAREHOUSE_VIEW,
            P.PRODUCT_VIEW, P.PRODUCT_COST_VIEW, P.PRICING_VIEW,
            P.STOCK_VIEW,
            P.SALE_VIEW, P.INVOICE_VIEW, P.INVOICE_ISSUE,
            P.CUSTOMER_VIEW, P.CUSTOMER_CREDIT_MANAGE, P.SUPPLIER_VIEW,
            P.PURCHASE_VIEW,
            P.PAYMENT_VIEW, P.PAYMENT_CREATE, P.PAYMENT_DELETE,
            P.EXPENSE_VIEW, P.EXPENSE_CREATE, P.EXPENSE_APPROVE,
            P.ACCOUNT_MANAGE, P.RECEIVABLE_VIEW, P.PAYABLE_VIEW,
            P.REPORT_VIEW, P.REPORT_FINANCIAL_VIEW, P.REPORT_EXPORT,
            P.AUDIT_VIEW,
        ],
        isSystem: true,
    },
    {
        name: 'Cashier',
        description: 'Sells at the register and takes payment.',
        permissions: [
            P.PRODUCT_VIEW, P.STOCK_VIEW,
            P.POS_ACCESS, P.POS_SESSION_OPEN,
            P.SALE_VIEW, P.SALE_CREATE, P.INVOICE_VIEW,
            P.CUSTOMER_VIEW, P.CUSTOMER_CREATE,
            // A till is an account: whoever counts one may open and correct one.
            P.PAYMENT_VIEW, P.PAYMENT_CREATE, P.ACCOUNT_MANAGE,
        ],
        isSystem: true,
    },
    {
        name: 'Salesperson',
        description: 'Quotes, orders and customer relationships.',
        permissions: [
            P.PRODUCT_VIEW, P.STOCK_VIEW, P.PRICING_VIEW,
            P.SALE_VIEW, P.SALE_CREATE, P.SALE_UPDATE, P.INVOICE_VIEW,
            P.CUSTOMER_VIEW, P.CUSTOMER_CREATE, P.CUSTOMER_UPDATE,
            P.PAYMENT_VIEW, P.REPORT_VIEW,
        ],
        isSystem: true,
    },
    {
        name: 'Warehouse Manager',
        description: 'Owns stock accuracy across warehouses.',
        permissions: [
            P.PRODUCT_VIEW, P.PRODUCT_CREATE, P.PRODUCT_UPDATE, P.PRODUCT_COST_VIEW,
            P.CATEGORY_MANAGE, P.UNIT_MANAGE, P.WAREHOUSE_VIEW, P.WAREHOUSE_UPDATE,
            P.STOCK_VIEW, P.STOCK_ADJUST, P.STOCK_TRANSFER, P.STOCK_TRANSFER_APPROVE,
            P.STOCK_COUNT, P.STOCK_COUNT_APPROVE, P.BATCH_MANAGE, P.SERIAL_MANAGE,
            P.PURCHASE_VIEW, P.PURCHASE_RECEIVE, P.PURCHASE_RETURN,
            P.SUPPLIER_VIEW, P.REPORT_VIEW, P.REPORT_EXPORT,
        ],
        isSystem: true,
    },
    {
        name: 'Warehouse Staff',
        description: 'Picks, receives and counts under supervision.',
        permissions: [
            P.PRODUCT_VIEW, P.WAREHOUSE_VIEW,
            P.STOCK_VIEW, P.STOCK_TRANSFER, P.STOCK_COUNT,
            P.PURCHASE_VIEW, P.PURCHASE_RECEIVE,
        ],
        isSystem: true,
    },
    {
        name: 'Procurement Officer',
        description: 'Sources stock and manages supplier relationships.',
        permissions: [
            P.PRODUCT_VIEW, P.PRODUCT_COST_VIEW, P.STOCK_VIEW,
            P.SUPPLIER_VIEW, P.SUPPLIER_CREATE, P.SUPPLIER_UPDATE,
            P.PURCHASE_VIEW, P.PURCHASE_CREATE, P.PURCHASE_UPDATE, P.PURCHASE_RECEIVE,
            P.PURCHASE_RETURN, P.PAYABLE_VIEW, P.REPORT_VIEW, P.REPORT_EXPORT,
        ],
        isSystem: true,
    },
    {
        name: 'Auditor',
        description: 'Read-only access to everything, including the audit log.',
        // AUDIT_VIEW already ends in _VIEW, so it is in VIEW_ONLY — the Set keeps
        // the list free of duplicates, which the (roleId, permissionCode) key rejects.
        permissions: [...new Set([...VIEW_ONLY, P.AUDIT_VIEW, P.REPORT_EXPORT])],
        isSystem: true,
    },
];
export const OWNER_ROLE_NAME = 'Owner';
//# sourceMappingURL=roles.js.map